import { Component } from '@angular/core';
import {  NavController, NavParams, ModalController, ViewController, ToastController } from 'ionic-angular';
import { BllSiparisDetay } from '../../providers/bll/bll-siparis-detay';
import { StokeklePage } from '../StokIslemleri/stokekle/stokekle';
import { CarisecPage } from '../faturaislemleri/carisec/carisec';
import { BllOrtak } from '../../providers/bll/bll-ortak';
import { Ortak } from '../../providers/ortak';
import { BarcodeScannerProvider } from '../../providers/barcode-scanner-provider';
import { OzetPage } from '../faturaislemleri/ozet/ozet';

/**
 * Generated class for the PerakendeSatisFaturasiOlusturPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

 
@Component({
  selector: 'page-perakende-satis-faturasi-olustur',
  templateUrl: 'perakende-satis-faturasi-olustur.html',
})
export class PerakendeSatisFaturasiOlusturPage {
  aranan = "";
  skip: number = 0;
  take: number = 100;
  stokListesi = [];
  aktifkullaniciadi = "";
  Cari: any = { ID: "", Definition_: "" };
  Siparis: any = {
    ID: "", StokKartID: "", IslemTuru: "", FaturaID: "", CariKartID: "", Miktar: "",
    BirimFiyat: "", Tutar: "", NetFiyat: "", Kdv: "", KdvOran: "", UrunAdi: "", IskontoOran1: "", IskontoOran2: "", IskontoOran3: ""
    , IskontoTutar: "", IskontoluBirimFiyat: "", SatirNo: ""
  };

  constructor(public navCtrl: NavController,
    public modalCtrl: ModalController,
    public view: ViewController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    private barcodeScanner: BarcodeScannerProvider,
    public toast: ToastController,
    public navParams: NavParams) {

      this.aktifkullaniciadi=this.ortak.aktifKullaniciAdi;
  }

  ionViewDidLoad() {
    this.carisec();
    this.urunAra();
    this.cacheTemizle();
  }
  carisec() {
    if (this.Cari.ID == "" || this.Cari.ID == null) {
      var modal = this.modalCtrl.create(CarisecPage);
      modal.onDidDismiss(a => {
        if (a != null) {
          this.Cari = a;
          if (this.Cari.ID > 1) {
          }
          else {
          }
        }
      });
      modal.present();
    }

  }
  carisec2() {
    var modal = this.modalCtrl.create(CarisecPage);
    modal.onDidDismiss(a => {
      if (a != null) {
        this.Cari = a;
        if (this.Cari.ID > 1) {
        }
        else {
        }
      }
    });
    modal.present();

  }
  urunler(e) {
    if (e.keyCode == 13) {
      this.urunAra();
    }
  }
  urunAra() {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("katid", "-1");
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "Stoklar", "", false).then(a => {
      var sonuc = <any>a;
      this.stokListesi = sonuc.SonucObject;
      if (this.stokListesi.length <= 0) this.stokekle();
    })
  }
  stokekle() {
    this.ortak.showConfirmAlert("Uyarı", "Ürün kayıtlı değil eklemek istermisiniz").then(a => {
      let modal = this.modalCtrl.create(StokeklePage, { barkod: this.aranan })
      modal.onDidDismiss(data => {
        this.ionViewDidLoad();

      })
      modal.present();
    });


  }
  urunItemClick(urun) {
    this.ortak.alertSatisAktarimPenceresi(urun).then(a => {
      var sonuc = <any>a;
      var values = sonuc.values;
      var Miktar = values.Miktar;
      var Fiyat = values.Fiyat;
      if (Miktar == "" || Miktar == null) {
        Miktar = 1;
      }
      this.Siparis.Miktar = Miktar;
      this.Siparis.BirimFiyat = Fiyat;
      this.Siparis.StokKartID = urun.ID;
      this.Siparis.CariKartID = this.Cari.ID;
      this.Siparis.IslemTuru = 1;
      this.Siparis.Tutar = Fiyat * Miktar;
      this.Siparis.NetFiyat = Fiyat * Miktar;
      this.Siparis.KdvOran = urun.Vat;
      this.Siparis.UrunAdi = urun.StokAdi;
      this.Siparis.IskontoOran1 = 0;
      this.Siparis.IskontoOran2 = 0;
      this.Siparis.IskontoOran3 = 0;
      this.Siparis.IskontoTutar = 0;
      this.Siparis.IskontoluBirimFiyat = 0;
      var bllSiparisDetay = new BllSiparisDetay();
      bllSiparisDetay.perakendefaturasiDetayEkle_Temp(this.Siparis.StokKartID, this.Siparis.CariKartID, this.Siparis.Miktar, this.Siparis.BirimFiyat, this.Siparis.Tutar,
        this.Siparis.KdvOran, this.Siparis.NetFiyat, -993, this.Siparis.UrunAdi, 255, this.aktifkullaniciadi).then(a => {
          this.presentToast(urun.StokAdi + " " + "Eklendi");
          this.aranan = "";
        })

    });


  }
  presentToast(mesaj) {
    let toast = this.toast.create({
      message: mesaj,
      duration: 1000,
      showCloseButton: true,
      position: 'top'
    });
    toast.present();
  }
  ozet() {
    let modal = this.modalCtrl.create(OzetPage, { faturatip: 3 });
    modal.onDidDismiss(data => {

    });
    modal.present();
  }
  barkodOkut() {
    this.barcodeScanner.barkodOku().then(a => {
      var sonuc = <any>a;
      this.aranan = sonuc.text;
      this.urunAra();

    })
  }
  cacheTemizle() {
    var bllSiparisDetay = new BllSiparisDetay();
    bllSiparisDetay.execRawQuery("DELETE FROM NL_Siparis WHERE siparisID = " + -993).then(b => {
    }).catch(x => {
      console.log(x);
    })
  }
  kapat() {
    this.view.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/perakende-satis-faturasi-olustur/perakende-satis-faturasi-olustur.ts